/**
* @description: 上机/落机打卡记录
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">

            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #signature_image_url="{ row }">
                    <hc-oss-image-list :value="row.signature_image_url" />
                </template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['detail'].open(scope.row)">{{ t('common.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>

        <Detail ref="detail" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw } from "vue";
import Detail from "./components/sign-detail.vue";
import { useAttendancePageI18n, t } from '@/composables/useAttendancePageI18n.js';

import { pageListApi } from "@/api/attendance/sign.js";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { listToMap } from "@/utils/utils";
const myElementRef = ref();
const searchBox = ref();
const detail = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const buildSourceMap = () => ([
    { label: t('attendance.clockIn'), value: 1 },
    { label: t('attendance.clockOut'), value: 2 }
]);

const buildStatusMap = () => ([
    { label: t('attendance.normal'), value: 1 },
    { label: t('attendance.late'), value: 2 },
    { label: t('attendance.earlyLeave'), value: 3 },
    { label: t('attendance.missing'), value: 4 },
    { label: t('attendance.abnormalLocation'), value: 5 },
]);

const sourceMap = reactive(buildSourceMap());
const statusMap = reactive(buildStatusMap());

const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0
    })
    userListApi(params).then(res => {
        searchData[0].children = res.data.map(i => {
            return { label: i.real_name, value: i.real_name }
        })
        getSearch(searchData)
    })
}

const searchData = reactive([
    { label: "", type: "select", value: "", field: 'keywords', children: [] },
    { label: "", type: "daterange", value: [], field: 'time', seditem: '', enditem: '' },
]);

const buildColumns = () => ([
    { prop: "id", show: false, label: "ID" },
    { show: true, type: "index", label: t('table.index'), width: 80 },
    { prop: "real_name", show: true, label: t('field.realName') },
    { prop: "mobile", show: true, label: t('field.mobile') },
    { prop: "signed_at", show: true, label: t('attendance.signTime') },
    { prop: "signature_image_url", show: true, label: t('attendance.signImage') },
    { prop: "operation", show: true, label: t('table.operation') },
]);

const applyLabels = () => {
    searchData[0].label = t('field.realName');
    searchData[1].label = t('common.startTime');
    Object.assign(sourceMap, buildSourceMap());
    Object.assign(statusMap, buildStatusMap());
    state.column = buildColumns();
    tableHeaderFn();
};

useAttendancePageI18n(applyLabels);

const state = reactive({
    title: "",
    column: buildColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: []
});

const init = () => {
    getUserList()
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
console.log(1)
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    console.log(2)
    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        applyLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

const getSearch = (params) => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    const requestParams = JSON.stringify({
        "keywords": searchData[0].value ?? '',
        "stime": timeData[0] ?? '',
        "etime": timeData[1] ?? '',
        "page": page.value,
        "limit": limit.value
    })
    state.loading = true

    pageListApi(requestParams).then(res => {
        maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data?.map(item => {
        return {
         ...item,
          source: listToMap(sourceMap, {})[item.source],
          status: listToMap(statusMap, {})[item.status],
        }
      })
    }).finally(() => {
    state.loading = false
  })
};

const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}

.record-img {
    width: 200px;
    height: 100px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
